/**
 * React, react redux and react localization imports
 */

// import { connect } from 'react-redux';

import { login } from '../../../api/auth'

/**
 * Material imports
 */
import GppBadIcon from '@mui/icons-material/GppBad'
import GppGoodIcon from '@mui/icons-material/GppGood'
import RemoveModeratorIcon from '@mui/icons-material/RemoveModerator'

/**
 * Relative exports to root directory
 */
import { Box, Paper } from '@mui/material'
import { useSelector } from 'react-redux'
import { useThemeMode } from '../../../theme'
import { Button } from './Button'
import { TranslatableTypography } from './Typography'

const getThemeSx = (palette) => ({
  box: {
    width: '100%',
    minHeight: '400px',
    padding: '5px',
    textAlign: 'center'
  },
  container: {
    maxWidth: '600px',
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'inline-block'
  },
  wrapper: {
    padding: '15px',
    textAlign: 'center'
  },
  icon: { fontSize: 120, color: palette.headerColor },
  typography: { fontWeight: 600, color: palette.headerColor },
  button: { marginTop: '30px' }
})

export const LoginDialog = () => {
  const { config } = useSelector((state) => state?.config)
  const { language } = useSelector((state) => state?.language)
  const { palette } = useThemeMode()
  const themeSX = getThemeSx(palette)

  const onLogin = () => {
    login(config, language)
  }

  return (
    <Box sx={themeSX.box}>
      <Paper sx={themeSX.container} elevation={3}>
        <Box sx={themeSX.wrapper}>
          <GppGoodIcon sx={themeSX.icon} />
          <TranslatableTypography sx={themeSX.typography}>
            companion-authorization
          </TranslatableTypography>
          <Button
            variant="filled"
            sx={themeSX.button}
            onClick={onLogin}
          >
            Continue
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}

export const LogoutDialog = () => {
  const { palette } = useThemeMode()
  const themeSX = getThemeSx(palette)
  return (
    <Box sx={themeSX.box}>
      <Paper sx={themeSX.container}>
        <Box sx={themeSX.wrapper}>
          <RemoveModeratorIcon sx={themeSX.icon} />
          <TranslatableTypography sx={themeSX.typography}>
            logout-success
          </TranslatableTypography>
        </Box>
      </Paper>
    </Box>
  )
}

const getLoginMenuItemThemeSx = (palette) => ({
  wrapper: {
    fontSize: 14,
    color: palette.paperColor,
    textAlign: 'center',
    padding: '15px'
  },
  icon: {},
  typography: { marginTop: '15px' },
  button: { marginTop: '15px' }
})

export const LoginMenuItem = () => {
  const { config } = useSelector((state) => state?.config)
  const { language } = useSelector((state) => state?.language)
  const { palette } = useThemeMode()
  const themeSX = getLoginMenuItemThemeSx(palette)

  const onLogin = () => {
    login(config, language)
  }

  return (
    <Box sx={themeSX.wrapper}>
      <GppGoodIcon sx={themeSX.icon} />
      <TranslatableTypography sx={themeSX.typography}>
        user-menu
      </TranslatableTypography>
      <TranslatableTypography sx={themeSX.typography}>
        companion-authorization
      </TranslatableTypography>
      <Button
        variant="invert-contained"
        sx={themeSX.button}
        onClick={onLogin}
      >
        login
      </Button>
    </Box>
  )
}

const getErrorDialogThemeSx = (palette) => ({
  box: {
    width: '100%',
    minHeight: '400px',
    padding: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    maxWidth: '600px',
    width: '100%',
    height: '100%',
    position: 'relative',
    boxShadow: '0px 0px 5px #20181d, 0px 0px 5px #20181d',
    display: 'inline-block'
  },
  wrapper: {
    padding: '15px',
    textAlign: 'center'
  },
  icon: { fontSize: 120, color: palette.headerColor },
  typography: { fontWeight: 600, color: palette.headerColor },
  button: { marginTop: '30px' }
})

export const ErrorDialog = (props) => {
  const { buttonText, children } = props
  const { config } = useSelector((state) => state?.config)
  const { language } = useSelector((state) => state?.language)
  const { palette } = useThemeMode()
  const themeSX = getErrorDialogThemeSx(palette)

  const onLogin = () => {
    login(config, language)
  }

  return (
    <Box sx={themeSX.box}>
      <Paper sx={themeSX.container} elevation={3}>
        <Box sx={themeSX.wrapper}>
          <GppBadIcon sx={themeSX.icon} />
          <TranslatableTypography sx={themeSX.typography}>
            {children}
          </TranslatableTypography>
          <Button
            variant="filled"
            sx={themeSX.button}
            onClick={onLogin}
          >
            {buttonText}
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}

export const AuthErrorDialog = (props) => {
  return (
    <ErrorDialog {...props} buttonText="retry">
      companion-authorization
    </ErrorDialog>
  )
}

export const NotRegisteredErrorDialog = (props) => {
  return (
    <ErrorDialog {...props} buttonText="retry">
      not-registered
    </ErrorDialog>
  )
}

export const AutomaticallyLogoutedDialog = (props) => {
  return (
    <ErrorDialog {...props} buttonText="retry">
      authentication-expired
    </ErrorDialog>
  )
}

export const NoAccessDialog = (props) => {
  return (
    <ErrorDialog {...props} buttonText="retry">
      no-access
    </ErrorDialog>
  )
}
